var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container"},[_c('Loader2',{staticClass:"loader-icon",attrs:{"size":48}}),_vm._v(" "),_c('p',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.getTranslations('expression_1495')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }